import React from 'react';
import {ReactComponent as CardView} from '../../../assets/icons/switch-card-view.svg';
import {ReactComponent as SolutionView} from '../../../assets/icons/switch-solution-view.svg';
import {ReactComponent as CardViewHover} from '../../../assets/icons/switch-card-view-hover.svg';
import {ReactComponent as SolutionViewHover} from '../../../assets/icons/switch-solution-view-hover.svg';

import { useStyles } from './SwitchView.styles';
import TooltipOne from '../../TooltipOne/TooltipOne.component';
import { IconButton } from '@material-ui/core';
import { fill, fillBlueYellow } from '../../../utils/contrastSvgAttributes';

interface SwitchViewProps {
  isCardPreview: boolean;
  isSolutionPreview: boolean;
  handleSwitchView: () => void;
}

export const SwitchView: React.FC<SwitchViewProps> = (props) => {
  const classes = useStyles();

  return (
    <div
      className={classes.switchViewOutline}
      style={{
        background: props.isCardPreview
          ? 'linear-gradient(90deg, #FFFFFF 50%, #D6D6FB 50%)'
          : 'linear-gradient(90deg, #D6D6FB 50%, #FFFFFF 50%)',
      }}
    >
      <TooltipOne title="Widok obrazu rozwiązania zadania" placement="top">
        <IconButton
          className={classes.switchViewIcon}
          onClick={props.isCardPreview ? props.handleSwitchView : undefined}
        >
          {' '}
          {props.isCardPreview ? <CardView fill={fill} /> : <CardViewHover fill={fillBlueYellow} />}
        </IconButton>
      </TooltipOne>
      <TooltipOne title="Widok całej karty" placement="top">
        <IconButton
          className={classes.switchViewIconRight}
          onClick={props.isSolutionPreview ? props.handleSwitchView : undefined}
        >
          {' '}
          {props.isSolutionPreview ? <SolutionView fill={fill} /> : <SolutionViewHover fill={fillBlueYellow} />}{' '}
        </IconButton>
      </TooltipOne>
    </div>
  );
};
